/**
 * Contains an array of `T` elements.
 */
export interface ListOf<T> {
  elements: T[]
}

/**
 * Metadata for loading a `PageOf` elements.
 */
export interface ListStatus {
  didLoadAll: boolean
  /**
   * Total count of elements in the API.
   */
  total: number
}

/**
 * A list of `T` elements that does not depend _directly_ on another element.
 */
export type BaseList<T> = ListOf<T> & ListStatus

/**
 * A relational object with ids of elements that depend on another element.
 */
export interface RelationalObject extends ListStatus {
  ids: Set<number>
}

/**
 * Maps the id of parent elements to a relational object of dependents.
 */
export type RelationMap<T extends RelationalObject> = Record<number, T>

/**
 * Creates a new empty base list.
 */
export function makeBaseList<T> (): BaseList<T> {
  return {
    elements: [],
    didLoadAll: false,
    total: 0
  }
}

/**
 * Creates a new empty relational object.
 */
export function makeRelationalObject (): RelationalObject {
  return {
    ids: new Set<number>(),
    didLoadAll: false,
    total: 0
  }
}
